import { formatDate } from '@/utils/date';
import { parseISO } from 'date-fns';
import { isValid as isValidDate } from 'date-fns';

function normalizeDateInput(input: unknown): string | Date | null {
  if (input instanceof Date) {
    return input;
  }
  if (typeof input !== 'string') {
    return null;
  }

  const trimmedInput = input.trim();
  const candidateDateStrings = [
    trimmedInput,
    trimmedInput.includes(' ') ? trimmedInput.replace(' ', 'T') : null
  ].filter(Boolean) as string[];

  const validDateString = candidateDateStrings.find((candidateString) =>
    isValidDate(parseISO(candidateString))
  );
  return validDateString ?? null;
}

export function normalizeToDisplayLabel(input: unknown): string | number | undefined {
  if (input == null) {
    return undefined;
  }
  if (typeof input === 'boolean') {
    return input ? 'Yes' : 'No';
  }

  const normalizedDate = normalizeDateInput(input);
  if (normalizedDate) {
    const formattedDate = formatDate(normalizedDate);
    if (formattedDate) {
      return formattedDate;
    }
  }

  if (typeof input === 'string' || typeof input === 'number') {
    return input;
  }

  if (typeof input === 'object') {
    const inputObject = input as Record<string, unknown>;
    const preferredProperty = (['label', 'name', 'value'] as const).find((propertyName) => {
      const propertyValue = inputObject[propertyName];
      return (
        propertyValue !== undefined &&
        (typeof propertyValue === 'string' || typeof propertyValue === 'number')
      );
    });
    if (preferredProperty) {
      return inputObject[preferredProperty] as string | number;
    }
  }

  return undefined;
}

export function previousValueLabel(
  current: unknown,
  previous: unknown
): string | number | undefined {
  const currentLabel = normalizeToDisplayLabel(current);
  const previousLabel = normalizeToDisplayLabel(previous);
  return previousLabel !== undefined && previousLabel !== currentLabel ? previousLabel : undefined;
}
